module.exports = __webpack_public_path__ + "static/scale-model-of-battle-friedman-house-&-gardens-in-tuscaloosa-alabama-a11485262b746289aa66564a5a981137.png";